window._ = require('lodash')
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.app  = window.app || {}
app.locale  = document.querySelector('html').getAttribute('lang')
app.errors  = []
app.success = []

// bootstrap
import './polyfill'
import './watermark'
import './browse-happy'

// controllers
import '../controllers'
